<template>
<div class="bg">  
  <div v-if="hideRedeem" style="position: fixed; width:100%; bottom:0; z-index:100; background-color:orange">
       <div class="col-sm-12" style="padding:20px; color:#000;">
          <div class="info-message" >
            <strong>Do not refresh or reload this page!</strong>
          </div>
        </div>                        
  </div>
  <div id="login">

    <section class="login-container registration-form">
      <div class="container">
    <div v-show="loading" class="loading">
      <i  class="fa fa-3x fa-spinner fa-spin"></i>
    </div>        
        <div class="col-md-4 col-md-offset-4 col-sm-4 col-sm-offset-4">
          <div class="login-form-container">
            <div class="login-form-header">
                <div class="logo">
                    <img style="width:180px" src="/static/images/logo-am.png" alt="logo">
                </div>
                <div class="partner">
                  <span class="disclaimer" v-html="disclaimer"></span> 
                  <img v-if="logo" v-bind:src="logo" style="width:120px;" alt="logo">
                </div>
            </div>            
             <form class="j-forms" id="forms-login" novalidate>
                    <div class="unit" v-if="loginErr">
                      <div class="error-message">
                        <i class="fa fa-close"></i>
                        <p>{{ loginErr }}</p>
                      </div>
                    </div>
                    
                    <div class="unit">
                      <p>Welcome to Audio Modeling Customer Portal</p>
                      <p>Here you can download your purchased products and manage the licences activations on your computers and devices.</p>
                    </div>             
                  <div class="login-form-content">
                    <div class="unit">
                      <h2>Register / Create an account</h2>
                    </div>


                    <div class="row">
                        <div class="col-md-12" v-if="signupErr">
                          <div class="error-message" v-if="signupErr">
                            <p v-for="error in signupErr">{{ error }}</p>
                          </div>
                        </div> 
                        <div class="col-sm-12 unit">
                          <div class="input login-input">
                            <label class="icon-left" for="first_name">
                              <i class="fa fa-user"></i>
                            </label>
                            <input v-model="credentials.first_name" v-validate="'required'" class="form-control required-group login-frm-input" type="text" name="first_name" data-vv-as="First name" id="first_name" placeholder="First name" @change="enableButton()" autofocus>
                            <span v-show="errors.has('first_name')" class="error-view">{{ errors.first('first_name') }}</span>
                          </div>
                        </div>
                        <div class="col-sm-12 unit">
                          <div class="input login-input">
                            <label class="icon-left" for="last_name">
                              <i class="fa fa-user"></i>
                            </label>
                            <input v-model="credentials.last_name" v-validate="'required'" type="text" class="required-group form-control login-frm-input" name="last_name" data-vv-as="Last name" id="last_name" placeholder="Last name" @change="enableButton()">
                            <span v-show="errors.has('last_name')" class="error-view">{{ errors.first('last_name') }}</span>
                          </div>
                        </div>
                     

                        <div class="col-sm-12 unit">
                          <div class="input login-input">
                            <label class="icon-left" for="username">
                              <i class="fa fa-user"></i>
                            </label>
                            <input v-model="credentials.username" v-validate="'required|alpha_num'" class="form-control required-group login-frm-input" type="text" name="username" data-vv-as="Username"  id="username" placeholder="Username" @change="enableButton()">
                            <span v-show="errors.has('username')" class="error-view">{{ errors.first('username') }}</span>
                          </div>
                        </div>
                        <div class="col-sm-12 unit">
                          <div class="input login-input">
                            <label class="icon-left" for="email">
                              <i class="fa fa-envelope-o"></i>
                            </label>
                            <input v-model="credentials.email" v-validate="'required|email'" class="form-control login-frm-input"  type="text" id="email" name="email" data-vv-as="Email"  placeholder="Email" @change="enableButton()">
                            <span v-show="errors.has('email')" class="error-view">{{ errors.first('email') }}</span>
                          </div>
                        </div>

                        <div class="col-sm-12 unit">
                          <div class="input login-input">
                            <label class="icon-left" for="password">
                              <i class="zmdi zmdi-key"></i>
                            </label>
                            <input v-model="credentials.password" v-validate="'required|verify_password'" class="form-control required-group login-frm-input" type="password" data-vv-as="Password"  name="password" id="password" ref="password" placeholder="Password" @change="enableButton()" @keyup.enter="signUp()">
                            <span v-show="errors.has('password')" class="error-view">{{ errors.first('password') }}</span>
                          </div>
                        </div>
                        <div class="col-sm-12 unit">
                          <div class="input login-input">
                            <label class="icon-left" for="pass_confirm">
                              <i class="zmdi zmdi-key"></i>
                            </label>
                            <input v-model="credentials.pass_confirm" v-validate="'required|confirmed:password'" data-vv-as="password" class="form-control login-frm-input"  type="password" id="pass_confirm" name="pass_confirm" placeholder="Confirm Password" @change="enableButton()" @click="enableButton()" @keyup.enter="signUp()" @keyup="enableButton()">
                            <span v-show="errors.has('pass_confirm')" class="error-view">{{ errors.first('pass_confirm') }}</span>
                          </div>
                        </div>
                    </div>

                    <div class="unit" v-if="!hideRedeem">
                      <h5><b>Enter your Redeem code or License Key to register also your transaction (optional - leave empty for free products)</b></h5>
                    </div>

                    <div class="row" v-if="!hideRedeem">
                      <div class="col-sm-12 unit">
                          <div class="input login-input">
                            <label class="icon-left" for="redeem_code">
                              <i class="fa fa-key"></i>
                            </label>
                            <input v-model="credentials.redeem_code" class="form-control login-frm-input" type="text" name="redeem_code" data-vv-as="Redeem code or License Key" id="redeem_code" placeholder="Redeem code or License Key for product registration">
                            <span v-show="errors.has('redeem_code')" class="error-view">{{ errors.first('redeem_code') }}</span>
                          </div>
                        </div>
                    </div>

                     
                    <div class="row"> 

                       <div class="col-sm-12 unit">
                          <label>
                            <span class="label-text"><span>How would you like to hear from us?<sup>*</sup></span></span>
                          </label>
                          <div class="form-check">
                            <label>
                              <input type="checkbox" name="gdpr_email" v-model="credentials.gdpr_email" @change="enableButton()"> <span class="label-text"><span>Newsletter (no monkey business, only good stuff: videos,tips and customized offers)</span></span>
                            </label>
                            <label>
                              <input type="checkbox" name="gdpr_advertising" v-model="credentials.gdpr_advertising" @change="enableButton()"> <span class="label-text"><span>Customized online ads, promo and news</span></span>
                            </label>
                          </div>
                          <div class="clearfix"></div>
                       </div>
                          
                      
                      <div class="col-sm-12 unit">

                          <div class="input login-input">                 
                            <button type="button" class="btn btn-primary btn-block" @click="signUp()" v-show="errors" v-bind:disabled="disableButton || loading"><i v-show="loading" class="zmdi zmdi-spinner"></i> Register</button>
                            
                            <span class="hint" style="margin-bottom:10px;">
                              <hr/>
                              <router-link to="recover" class="link">Forgot password?</router-link>
                              <router-link to="login" class="link">Do you have an account?</router-link>

                            </span>
                          </div>
                      </div>
                      <div class="col-sm-12 unit">

                          <div class="input login-input">  
                          <router-link :to="{ path: '/login', query: $route.query.redeem_code ? { redeem_code: $route.query.redeem_code } : null }" class="link">
                          <button type="button" class="btn-block btn btn-black">Login</button>  
                          </router-link>
                          </div>
                      </div>
                      <div class="col-sm-12 unit">
                      <p><small class="gdpr">
                          <sup>*</sup>The mandatory information you provide through this form is needed to supply the service. Audio Modeling Srl can use such information also to be in touch with you and to provide updates and marketing.
                            You can change your mind at any time by contacting us at <a href="mailto:support@audiomodeling.com">support@audiomodeling.com</a>. We will treat your information with respect. For more information about our privacy practices please visit <a target="_blank" href="https://audiomodeling.com/privacy-policy">https://audiomodeling.com/privacy-policy</a> . By clicking "Register", you agree that we may process your information in accordance with these terms.
                          </small></p>
                      </div>
                      </div>


                  </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
</template>

<script>
  import auth from '../auth'
  import VeeValidate from 'vee-validate'



  export default {
    data () {
      return {
        credentials: {
          first_name: '',
          last_name: '',
          username: '',
          email:'',
          password: '',
          pass_confirm:''
        },
        payload: null,
        logo: '',
        style: '',
        signupErr: '',
        disableButton: true,
        loading: false,
        loginErr: '',
        disclaimer: '',
        hideRedeem: false,
        promo: null,
        redeem_code: null
      }
    },
    methods:{
      enableButton(){
        this.$validator.validateAll()
        if (this.$validator.errors.items.length == 0){        
          this.disableButton = false
        }else{
          this.disableButton = true
        }
      },
      signUp() {
        this.$validator.validateAll()
        if (this.$validator.errors.items.length == 0){
          var credentials = {
            first_name: this.credentials.first_name ? this.credentials.first_name : '',
            last_name: this.credentials.last_name ? this.credentials.last_name : '',
            username: this.credentials.username ? this.credentials.username : '',
            email: this.credentials.email ? this.credentials.email : '',
            password: this.credentials.password ? this.credentials.password : '',
            password_confirm: this.credentials.pass_confirm ? this.credentials.pass_confirm : '' ,
            gdpr_email: this.credentials.gdpr_email ? this.credentials.gdpr_email : '',
            gdpr_advertising: this.credentials.gdpr_advertising ? this.credentials.gdpr_advertising : '',
            ref_token: localStorage.getItem('ref_token') ? localStorage.getItem('ref_token') : '',
            redeem_code: this.$route.query.redeem_code ? this.$route.query.redeem_code : this.credentials.redeem_code,
          }
          auth.signup(this, credentials)
        }
      }
    },
    created(){
      if(this.$route.query.promo){
        this.credentials.first_name = this.$route.query.first_name
        this.credentials.last_name = this.$route.query.last_name
        this.credentials.email = this.$route.query.email
        this.credentials.redeem_code = this.$route.query.redeem_code
        localStorage.setItem('promo_first_name',this.$route.query.first_name)
        localStorage.setItem('promo_last_name',this.$route.query.last_name)
        localStorage.setItem('promo_email',this.$route.query.email)
        localStorage.setItem('promo_redeem_code',this.$route.query.redeem_code)
        localStorage.setItem('promo',this.$route.query.promo)
        this.promo = this.$route.query.promo
        this.redeem_code = this.$route.query.redeem_code
      }
      if(this.$route.query.source){
        auth.prefill(this,this.$route.query.source,this.$route.query.payload)
      }
      if(localStorage.getItem('ref_first_name')) this.credentials.first_name = localStorage.getItem('ref_first_name')
      if(localStorage.getItem('ref_first_name')) this.credentials.last_name = localStorage.getItem('ref_last_name')
      if(localStorage.getItem('ref_email')) this.credentials.email = localStorage.getItem('ref_email')

        if(localStorage.getItem('ref_token')) this.hideRedeem = true

      
      VeeValidate.Validator.extend('verify_password', {
          getMessage: field => 'The password must be at least 8 characters and must contain an uppercase letter, a lowercase letter, a number, and one special character (E.g. , . _ & ? etc)',
          validate: value => {
            var strongRegex = /^(?=\S*[a-z])(?=\S*[A-Z])(?=\S*\d)(?=\S*([^\w\s]|[_]))\S{8,}$/g;
            return strongRegex.test(value);
          }
      }) 

      const dictionary = {
        en: {
          attributes: {
            first_name: 'First Name',
            last_name: 'Last Name'
          }
        }
      };

      VeeValidate.Validator.localize(dictionary); 
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.bg{width:100%; height:100%;}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

input[type="checkbox"], input[type="radio"]{
  position: absolute;
  right: 9000px;
}

label{
  position: relative;
  cursor: pointer;
  color: #666;
  font-size: 160%;
}

/*Check box*/
input[type="checkbox"] + .label-text:before{
  content: "\f096";
  font-family: "FontAwesome";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing:antialiased;
  width: 1em;
  display: inline-block;
  margin-right: 5px;
  vertical-align: middle;
}

input[type="checkbox"]:checked + .label-text:before{
  content: "\f14a";
  color: #2980b9;
  animation: effect 250ms ease-in;
}

input[type="checkbox"]:disabled + .label-text{
  color: #aaa;
}

input[type="checkbox"]:disabled + .label-text:before{
  content: "\f0c8";
  color: #ccc;
}

label span.label-text span{
  font-size:75% !important;
}

p small.gdpr{
  color:#2c3e50 !important;
  margin-top:20px;
}

@keyframes effect{
  0%{transform: scale(0);}
  25%{transform: scale(1.3);}
  75%{transform: scale(1.4);}
  100%{transform: scale(1);}
}
.logo{
  margin-bottom:30px;
}
.disclaimer{margin-right: 10px;}
.partner{margin:auto; margin-bottom:30px;}

</style>



// WEBPACK FOOTER //
// src/components/Register.vue